module.exports = __webpack_public_path__ + "img/i6.a030b0c2.png";